module.exports = __webpack_public_path__ + "assets/img/tx230_4.9e7dd246.jpg";